/**
 * Sprint 23.8 — Workspace info sidebar block (block 1).
 *
 * Plan / Members / {agents} / Since, as label↔value rows. Reads the batched
 * overview (shared, cached query — no extra fetch).
 */

import { type CSSProperties } from "react";
import { SidebarBlock } from "../shell/SidebarBlock";
import { useThemedLabels } from "../../hooks/use-themed-labels";
import { useWorkspaceOverview } from "../../hooks/use-workspace-overview";
import { formatSince } from "./format";

function capitalize(s: string): string {
  return s.length ? s[0]!.toUpperCase() + s.slice(1) : s;
}

export function WorkspaceInfoBlock() {
  const labels = useThemedLabels();
  const { data } = useWorkspaceOverview();

  return (
    <SidebarBlock title="Workspace" isFirst>
      <div style={rows}>
        <Row label="Plan" value={data ? capitalize(data.plan) : "—"} />
        <Row label="Members" value={data ? String(data.members_count) : "—"} />
        <Row label={capitalize(labels.unitPlural)} value={data ? String(data.agents_count) : "—"} />
        <Row label="Since" value={formatSince(data?.workspace?.created_at)} />
      </div>
    </SidebarBlock>
  );
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <div style={row}>
      <span style={rowLabel}>{label}</span>
      <span style={rowValue}>{value}</span>
    </div>
  );
}

const rows: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: 5,
  fontSize: 12,
};

const row: CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  gap: 8,
};

const rowLabel: CSSProperties = {
  color: "var(--color-text-tertiary)",
};

const rowValue: CSSProperties = {
  color: "var(--color-text-primary)",
};
